var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
// @flow
// @ts-nocheck
import React, { Component } from "react";
// utils
import { appNames, standardWmsSizes } from "@shared/utils/constants";
import { FormattedMessage } from "react-intl";
import { getPriceString, hasDiscounts } from "@shared/utils/currency";
import sortBy from "lodash/sortBy";
// components
import ArticleCrossSelling from "organisms/ArticleCrossSelling";
import ArticleImages from "organisms/ArticleImages";
import AvailableLegend from "molecules/AvailableLegend";
import ControlledSlider from "@shared/molecules/ControlledSlider";
import DiscountBadgeBig from "molecules/DiscountBadgeBig";
import ArticleMoreInformation from "@shared/organisms/ArticleMoreInformation";
import NavIcon from "atoms/NavIcon";
import PriceTag from "@shared/molecules/PriceTag";
import ScrollBottomButton from "atoms/ScrollBottomButton";
import SizeSelect from "molecules/SizeSelect";
import SliderArticle from "molecules/SliderArticle";
import WatchlistButton from "molecules/WatchlistButton";
import { ActionsBlock, Block, BrandImage, CloseStack, Headline, InfoArea, InfoBlock, Light, Main, MainWrapper, Price, Slide, StockInformation, SubHeadline, WmsSize, Wrapper } from "./style";
var ArticleView = /** @class */ (function (_super) {
    __extends(ArticleView, _super);
    function ArticleView(props) {
        var _this = _super.call(this, props) || this;
        window.sessionStorage.removeItem("trackedArticleId");
        _this.setContainerRef = function (el) {
            if (!_this.state.containerRef) {
                _this.setState({
                    containerRef: el
                });
            }
        };
        _this.state = {
            currentSize: null,
            containerRef: null
        };
        _this.handleSizeSelect = function (size) {
            var _a = _this.props, article = _a.article, saveHidden = _a.saveHidden;
            _this.setState({
                currentSize: size.sizeId
            });
            saveHidden({
                articleId: article.id,
                sizeId: size.sizeId
            });
        };
        _this.getDesiredPrices = function (article) {
            var _a;
            var firstAvailableSize = (_a = article.sizes) === null || _a === void 0 ? void 0 : _a.find(function (size) {
                return size.stock === "available";
            });
            if (firstAvailableSize) {
                return { min: firstAvailableSize.price, max: firstAvailableSize.price };
            }
            else {
                return article.prices;
            }
        };
        _this.getCurrentPrice = function () {
            var _a, _b;
            var article = _this.props.article;
            var prices = article.prices, targetPrices = article.targetPrices;
            if (!prices && !targetPrices) {
                return _jsx(_Fragment, {}, void 0);
            }
            if (_this.state.currentSize) {
                var size = (_b = (_a = _this.props.article) === null || _a === void 0 ? void 0 : _a.sizes) === null || _b === void 0 ? void 0 : _b.find(function (si) { return si.sizeId === _this.state.currentSize; });
                if (size) {
                    if (size.price < size.targetPrice) {
                        return (_jsxs("span", { children: [_jsx(Price, __assign({ crossed: true }, { children: getPriceString(size.targetPrice) }), void 0), " ", _jsx(Price, __assign({ discount: true }, { children: getPriceString(size.price) }), void 0), " "] }, void 0));
                    }
                    return _jsx(Price, { children: getPriceString(size.price) }, void 0);
                }
            }
            //DEV-308
            var desiredPrices = _this.getDesiredPrices(article);
            return _jsx(PriceTag, { prices: desiredPrices, targetPrices: desiredPrices }, void 0);
        };
        _this.isDiscounted = function () {
            var _a;
            var article = _this.props.article;
            if (!article.prices && !article.targetPrices) {
                return false;
            }
            if (!_this.state.currentSize) {
                return hasDiscounts(article.prices, article.targetPrices);
            }
            var size = (_a = article.sizes) === null || _a === void 0 ? void 0 : _a.find(function (si) { return si.sizeId === _this.state.currentSize; });
            if (size) {
                return size.price < size.targetPrice;
            }
            return false;
        };
        _this.getColorVariants = function () {
            var article = _this.props.article;
            var variants = [];
            // Only generate color selection, when base article has color variants
            if (article &&
                article.relatedArticles &&
                Boolean(article.relatedArticles) &&
                article.relatedArticles.length > 0) {
                // der aktuelle Artikel soll nicht auf die Liste
                // variants.push(article);
                variants = variants.concat(article.relatedArticles);
            }
            return variants;
        };
        return _this;
    }
    ArticleView.prototype.componentWillReceiveProps = function (nextProps) {
        if (this.props.params.id !== nextProps.params.id) {
            // Reset size select
            this.setState({
                currentSize: null
            });
        }
    };
    // This is added as work around to allow translations on ids with variables not static
    ArticleView.prototype.FormattedMessageFixed = function (props) {
        return _jsx(FormattedMessage, __assign({}, props), void 0);
    };
    ArticleView.prototype.render = function () {
        var _this = this;
        var _a, _b, _c, _d, _e, _f, _g, _h, _j;
        var _k = this.props, article = _k.article, createArticleStack = _k.createArticleStack, createWatchlistItem = _k.createWatchlistItem, deleteArticleStack = _k.deleteArticleStack, deleteWatchlistItem = _k.deleteWatchlistItem, nested = _k.nested, openImagesModal = _k.openImagesModal, params = _k.params, hidden = _k.hidden, watchlist = _k.watchlist;
        var _l = this.state, currentSize = _l.currentSize, containerRef = _l.containerRef;
        var watchlistItem = Boolean(article)
            ? watchlist.find(function (item) {
                return item.articleId === article.id && item.sizeId === currentSize;
            })
            : null;
        var currentSizeItem = (_a = article === null || article === void 0 ? void 0 : article.sizes) === null || _a === void 0 ? void 0 : _a.find(function (size) { return (size === null || size === void 0 ? void 0 : size.sizeId) === currentSize; });
        var colorVariants = this.getColorVariants();
        var articleWmsSize = "";
        var articleSizeTransId = "";
        try {
            if (undefined !== article.content && ((_b = article.content) === null || _b === void 0 ? void 0 : _b.length) > 0) {
                var widthContent = article.content.filter(function (contentAttribute) { return contentAttribute.name === "width"; });
                articleWmsSize = widthContent.length
                    ? standardWmsSizes[widthContent[0].value.toLowerCase()]
                    : "";
                articleSizeTransId = "article.sizes." + articleWmsSize;
            }
        }
        catch (e) {
            articleWmsSize = "";
        }
        if (!(article === null || article === void 0 ? void 0 : article.id)) {
            return _jsx(_Fragment, {}, void 0);
        }
        return (_jsxs(Wrapper, __assign({ innerRef: function (el) { return el && _this.setContainerRef(el); } }, { children: [typeof deleteArticleStack === "function" && (_jsx(CloseStack, { children: _jsx(NavIcon, { icon: "closex", width: 15, onClick: function () {
                            deleteArticleStack();
                            window.sessionStorage.setItem("trackedArticleId", article.id);
                        } }, void 0) }, void 0)), _jsx(MainWrapper, { children: _jsxs(Main, { children: [_jsx(ArticleImages, { hidden: hidden, article: article, nested: nested, openImagesModal: openImagesModal }, void 0), _jsxs(InfoArea, { children: [this.isDiscounted() && _jsx(DiscountBadgeBig, {}, void 0), _jsx("div", __assign({ hidden: !((_c = article.v2) === null || _c === void 0 ? void 0 : _c.brandImage) }, { children: _jsx(BrandImage, { src: (_d = article.v2) === null || _d === void 0 ? void 0 : _d.brandImage }, void 0) }), void 0), _jsxs(InfoBlock, { children: [_jsxs("div", { children: [_jsx(Headline, { children: ((_e = article === null || article === void 0 ? void 0 : article.v2) === null || _e === void 0 ? void 0 : _e.brand) || "-" }, void 0), _jsx("br", {}, void 0), article.displayName && _jsx(Light, { children: article.displayName }, void 0), _jsx("br", {}, void 0), _jsx(Light, { children: ((_f = article === null || article === void 0 ? void 0 : article.v2) === null || _f === void 0 ? void 0 : _f.color) || "-" }, void 0), _jsx("br", {}, void 0), _jsx(Light, { children: ((_g = article === null || article === void 0 ? void 0 : article.v2) === null || _g === void 0 ? void 0 : _g.material) || "-" }, void 0), article.number && _jsxs("div", __assign({ style: { marginTop: "1rem" } }, { children: ["Art.Nr. ", article.number] }), void 0)] }, void 0), _jsx(Block, { children: _jsxs(Headline, { children: [this.getCurrentPrice(), articleWmsSize && (_jsxs(WmsSize, { children: [_jsx(FormattedMessage, { id: "article.width", defaultMessage: "Weite" }, void 0), ":", " ", _jsx(this.FormattedMessageFixed, { id: articleSizeTransId, defaultMessage: articleWmsSize }, void 0)] }, void 0))] }, void 0) }, void 0), Boolean(colorVariants) && colorVariants.length > 0 && (_jsxs(Block, { children: [_jsx(SubHeadline, { children: _jsx(FormattedMessage, { id: "article.colors.headline", defaultMessage: "Farben" }, void 0) }, void 0), _jsx(ControlledSlider, __assign({ customWidth: "95%" }, { children: sortBy(colorVariants, "id").map(function (colorVariant) { return (_jsx(Slide, { children: _jsx(SliderArticle, { article: colorVariant, active: colorVariant.id === article.id, openArticle: _this.props.openColor }, void 0) }, "related" + colorVariant.id)); }) }), void 0)] }, void 0)), ((_h = article.sizes) === null || _h === void 0 ? void 0 : _h.length) > 0 && (_jsx(SizeSelect, { clickHandler: function (size) { return _this.handleSizeSelect(size); }, current: currentSize, currentArticleId: article.id, sizes: article.sizes }, void 0)), _jsx(AvailableLegend, { size: (_j = article.sizes) === null || _j === void 0 ? void 0 : _j.find(function (item) { return item.sizeId === currentSize; }) }, void 0), _jsx(ActionsBlock, { children: _jsx(WatchlistButton, { onList: Boolean(watchlistItem) &&
                                                        // $FlowIgnoreNextLine
                                                        watchlistItem.sizeId === currentSize, addAction: this.props.createWatchlistItem, removeAction: this.props.deleteWatchlistItem, watchlistItem: Boolean(watchlistItem) ? watchlistItem : null, articleId: article.id, sizeId: currentSize }, void 0) }, void 0), currentSize && currentSizeItem.stock === "inDifferentStore" && (_jsxs(StockInformation, { children: [_jsx("thead", { children: _jsxs("tr", { children: [_jsx("th", { children: _jsx(FormattedMessage, { id: "stock.branch", defaultMessage: "Filiale" }, void 0) }, void 0), _jsx("th", { children: _jsx(FormattedMessage, { id: "stock.amount", defaultMessage: "Weite" }, void 0) }, void 0), _jsx("th", { children: _jsx(FormattedMessage, { id: "stock.address", defaultMessage: "Weite" }, void 0) }, void 0)] }, void 0) }, void 0), _jsx("tbody", { children: currentSizeItem.stores.map(function (stock) { return (_jsxs("tr", { children: [_jsx("td", { children: stock.id }, void 0), _jsx("td", { children: stock.amount }, void 0), _jsx("td", { children: stock.address || "k.A." }, void 0)] }, void 0)); }) }, void 0)] }, void 0))] }, void 0)] }, void 0), _jsx(ArticleMoreInformation, { appName: appNames.TERMINAL, article: article, params: params }, void 0), _jsx(ArticleCrossSelling, { article: article, createArticleStack: createArticleStack, createWatchlistItem: createWatchlistItem, deleteWatchlistItem: deleteWatchlistItem, nested: nested, params: params, watchlist: watchlist }, void 0)] }, void 0) }, void 0), containerRef &&
                    containerRef.scrollHeight > containerRef.clientHeight && (_jsx(ScrollBottomButton, { wrapper: containerRef }, void 0))] }), void 0));
    };
    return ArticleView;
}(Component));
export default ArticleView;
